import React from 'react';

import './TableHeader.scss';

const titles = ["DNS", "Site Status", "Last Seen", "Cameras"];

const TableHeader = ()=> {
  return (
    <div className="table-header">
      {
        titles.map(title => <span key={title}>{title}</span>)
      }
    </div>
  );
};

export default TableHeader;